export const windowLocationOrigin = typeof window !== "undefined" && window.location.origin || 'https://www.divissa.com.tr';


const getEnvironment = () => {
  if (windowLocationOrigin.includes('localhost') || windowLocationOrigin.includes('devissa.com')) {
    return 'DEV';
  } else if (windowLocationOrigin.includes('previssa.com')) {
    return 'PREPROD';
  } else if (windowLocationOrigin.includes('divissa.com.tr')) {
    return 'PROD';
  }
  return 'DEV'; 
};

const currentEnv = getEnvironment();


const getEnvVar = (varName: string) => {
  const envVar = import.meta.env[`VITE_${varName}_${currentEnv}`];
  if (!envVar) {
    console.warn(`Environment variable VITE_${varName}_${currentEnv} not found`);
    return import.meta.env[`VITE_${varName}_DEV}`] || ''; // fallback to DEV
  }
  return envVar;
};


const backendUrl = windowLocationOrigin.includes('localhost') ||
    windowLocationOrigin.includes('devissa.com')
    ? 'http://api.devissa.com'
    : windowLocationOrigin.includes('previssa.com')
        ? 'https://api.previssa.com'
        : windowLocationOrigin.includes('divissa.com.tr')
            ? 'https://api.divissa.com.tr'
            : 'http://api.devissa.com';
 
export const callbackUrl = windowLocationOrigin + '/odeme-sonuc';
export const API_BASE_URL = `${backendUrl}/api/v1/`;
export const API_BASE = backendUrl;

// Diğer configler
export const googleMapsApiKey = getEnvVar('GOOGLE_MAPS_API_KEY');
export const recaptchasSiteKey = getEnvVar('RECAPTCHA_SITE_KEY');
export const googleSignInClientId = getEnvVar('GOOGLE_SIGN_IN_CLIENT_ID');
export const googleCalendarApiKey = getEnvVar('GOOGLE_CALENDAR_API_KEY');
export const dsnAddress = getEnvVar('SENTRY_DSN');

